<template>
    <div class="toast-row">
    <div class="toast-wrap" v-bind:class="{['variant-'+variant]: variant, ['width-'+width]: width}">
        <div class="toast-inner">
            <slot></slot>
        </div>
    </div>
    </div>
</template>
<script>
    export default {
        name: 'Toast',
        components: {
        },
        props: {
            variant: {
                type: String,
                default: 'default'
            },
            width: {
                type: String,
                default: 'full'
            }
        },
        data () {
            return {

            }
        },
        computed: {

        },
        mounted(){


        },
        methods: {

        }
    }
</script>
<style src="./Toast.scss" scoped lang="scss"></style>
